import ajaxRequest from './ajax'
import qs from "qs"

// 获取现场会议室列表
export const get_meeting_room_list = data => {
  return ajaxRequest.post("meeting_room/meeting_room_list",
    data,
  )
}

// 根据event来获取session list
export const get_session_list = params => {
  return ajaxRequest.get('session/get_session_list?' + qs.stringify(params));
}

//根据session id 判断用户是否在会议中
// 获取session详情
export const get_session_detail = params => {
  return ajaxRequest.post('session/get_session_detail?' + qs.stringify(params));
}

//根据session id 获取播流地址
export const get_broadcast_address = params => {
  return ajaxRequest.post("session/get_broadcast_address?" + qs.stringify(params));
}

// 根据session id 获取播流列表
export const get_vod_play_list = params => {
  return ajaxRequest.get('vod/get_vod_play_list?' + qs.stringify(params));
}

//更新直播状态
export const update_broadcast_session_status = (params) => {
  return ajaxRequest.post("session/update_broadcast_session_status?" + qs.stringify(params));
}

//根据频道获取session
export const get_session_list_by_channel_id = params => {
  return ajaxRequest.get("session/get_session_list_by_channel_id?" + qs.stringify(params))
}
//获取最近session（默认三条）
export const get_session_list_by_user_recent = params => {
  return ajaxRequest.get("session/get_session_list_by_user_recent?" + qs.stringify(params))
}
// export const get_session_list_by_user_recent_v2 = params => {
//   return ajaxRequest.post("session/get_session_list_by_user_recent_v2", params)
// }
// 根据session获取attendee列表
export const get_session_attendee_list = params => {
  return ajaxRequest.post("session/get_session_attendee_list", params);
}

// 根据session获取在线attendee列表
export const get_online_users_by_session = params => {
  return ajaxRequest.post("session/get_online_users_by_session", params);
}

//参会人获取媒体资源
export const get_session_media_list_by_attendee = params => {
  return ajaxRequest.get("session/get_session_media_list_by_attendee?" + qs.stringify(params))
}

export const get_session_by_announcer_uid = params => {
  return ajaxRequest.post('session/get_session_by_announcer_uid');
}

export const get_user_recommended_session = params => {
  return ajaxRequest.post('session/get_user_recommended_session', params);
}

export const get_session_list_by_user_recent_v2 = params => {
  return ajaxRequest.post('session/get_session_list_by_user_recent_v2', params);
}

// 获取参会人信息
export const get_attendee = id => {
  return ajaxRequest.get("session/get_attendee?event_id=" + id)
}
// 更新参会人信息
export const update_attendee = data => {
  return ajaxRequest.post("session/update_attendee", data)
}

// 获取vss相关的session
export const get_vss_session_by_event = id => {
  return ajaxRequest.get("session/get_vss_session_by_event?event_id=" + id)
}



// WEBPACK FOOTER //
// ./src/api/session.js